function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 15" {...props}><path fill="currentColor" d="M8.6.9C4.3.9.9 3.6.9 7c0 1.4.6 2.7 1.6 3.7l-.4 2.6c-.1.4.2.7.6.8h.1c.1 0 .2 0 .3-.1l3.1-1.3c.8.2 1.6.3 2.4.3 4.3 0 7.7-2.7 7.7-6.1 0-3.3-3.5-6-7.7-6zm-4.7 9.8c0-.2 0-.5-.2-.6-1-.9-1.5-2-1.5-3.1 0-2.7 2.9-5 6.4-5C12.1 2 15 4.3 15 7s-2.9 4.9-6.4 4.9c-.8 0-1.5-.1-2.3-.3h-.5l-2.2 1 .3-1.9z" /></svg>;
});